import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/types/state';

import { isAdmin } from '@/utils/isAdmin';
import { isModerator } from '@/utils/isModerator';

export const selectPasses = (state: RootState) => state.user.passes;
export const selectPassId = (state: RootState) => state.user.passId;
export const selectIsFullDay = (state: RootState) => state.user.isFullDay;
export const selectAccessToken = (state: RootState) =>
	state.user.user?.access_token;
export const selectFrom = (state: RootState) => state.user.from;
export const selectUser = (state: RootState) => state.user.user;
export const selectUsername = (state: RootState) =>
	state.user.person?.full_name;
export const selectPerson = (state: RootState) => state.user.person;
// Профиль может ещё не загрузиться или потеряться при прерванном входе — id берём из сессии
export const selectPersonId = (state: RootState) =>
	state.user.person?.id ?? state.user.user?.user?.person_id;
export const selectReplacedPersonId = (state: RootState) => state.user.replacedPersonId;
export const selectClientId = (state: RootState) => state.user.clientId;
export const selectIsActiveBookingShown = (state: RootState) =>
	state.user.isActiveBookingShown;

export const selectIsAdmin = createSelector(
	selectUser,
	(user) => user && isAdmin(user),
);
export const selectIsModerator = createSelector(
	selectPasses,
	(passes) => passes && isModerator(passes),
);
export const selectTargetClient = createSelector(
	selectClientId,
	selectPersonId,
	(clientId, personId) => clientId ?? personId,
);
